import { Component } from '@angular/core';
import { ORCIDResearchResourceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Research Resources') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidresearchresource-form',
    templateUrl: './orcidresearchresource.form.component.html'
})
export class ORCIDResearchResourceFormComponent extends BaseFormComponent {
    public record!: ORCIDResearchResourceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

